import axios from 'axios';
import React, {useContext, useEffect, useState} from 'react';
import { Card, Col, Container, Row, Form, Button, Alert } from 'react-bootstrap';
import { Key } from 'react-bootstrap-icons'
import { useNavigate, useLocation} from 'react-router-dom';
import AuthContext from '../../../context/AuthProvider';


const VALIDATE_EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
const LOGIN_URL = 'http://localhost:8000/user/login'

function DisplayReasonForVerification ({registrationType}) {
    
    return (
        <div>
            <Alert variant='warning' className= { registrationType == 'Password change'? ('show'):('hide')}>
                Before reseting your password, we must first verify your email. 
                Please click the button below to receive a one-time password (OTP). 
                This OTP will be valid for one hour. 
                After receiving it, you can enter the passcode below to verify your 
                email address.
            </Alert>

            <Alert variant='warning' className= { registrationType == 'newUser'? ('show'):('hide')}>
                To activate your account, we need to verify your email address. 
                Please click the button below to receive a one-time password (OTP). 
                This OTP will be valid for one hour. After receiving it, 
                you can enter the passcode below to verify your email address.
            </Alert>
        </div>
    )
}
export default function VerifyAccount() {
    const navigate = useNavigate()
    const location = useLocation()
    const registrationType = location.state.registrationType || '';
    const [email, setEmail] = useState(location.state.email || '');

    const {auth, setAuth} = useContext(AuthContext)
    const [isMounted, didMount] = useState(false)
    const [loadingOtpVerification, isLoadingOtpVerification] = useState(true)
    

    const [userOTP, setUserOTP] = useState()
    const [codeSent, setCodeSent] = useState(false)
    const [otpVerified, setOtpVerified ] = useState(false)
    const [resetType, setResetType] = useState('')
    const [showOtpInputField, setShowOtpInputField] = useState(false)

    const [errMsg, setErrMsg] = useState('')

    useEffect(()=> {
        didMount(true)
    },[])

    useEffect(()=> {
        if (isMounted) {
            isLoadingOtpVerification(false)
        }
    }, [isMounted])

    const sendOTP = async (e) => {
        e.preventDefault()
        setErrMsg('')
        setUserOTP('')
        setShowOtpInputField(false)
        try {
            await axios.post("/user/send-otp", { email: email.toLowerCase(), registrationType})
            setShowOtpInputField(true)
            setCodeSent(true)
        } catch (error) {
            setErrMsg(error.response.data.message)
            setShowOtpInputField(false)
            setCodeSent(false)
            setUserOTP('')
        }

    }
    const onSubmit = async (e) => {
        e.preventDefault()
        setErrMsg('')
        //send post request to back end to see if OTP is valid
        const result = await axios.post("/user/verify-otp", { 
                email: email.toLowerCase(), 
                otp: userOTP, 
                time: Date.now(), 
                registrationType 
            })  
            .then((res) => {
                return res
            }).catch ((error)=> {
                console.log(error)
                if (error.response.data.message == "No account exists under this email.") {
                    setUserOTP('')
                    setShowOtpInputField(false)
                    setCodeSent(false)
                    setErrMsg("No account exists under this email.")
                } else if(error.response.data.message == "Server Not Able to Verify OTP at the moment") {
                    setErrMsg("Sorry, we are not able to verify your account at the moment. Please try again at a later time.")
                } else {
                    setErrMsg("Unexpected Internal Error. Please try again at a later time.")
                }
                
                return error.response
            })
        
        // if otp is valid, reset password
        if (result.data.validOTP) {
            setErrMsg('')
            setOtpVerified(true)
            
        } else {
            //OTP is not valid
            setErrMsg(result.data.message)
            setOtpVerified(false)
        }
        
    }


    const otpFormView = () => {

        return(
            <Card>
            <Card.Header> Account Verification </Card.Header>
                <Card.Body>

                <DisplayReasonForVerification registrationType={registrationType} />

                <Form onSubmit={onSubmit}>

                    <Form.Group>
                        <Form.Control 
                        type="text"
                        placeholder="Enter your email"
                        value={email}
                        disabled = { codeSent ? true : false } // disable input field if OTP has been sent
                        onChange={e=>setEmail(e.target.value)}
                         />
                        
                    </Form.Group>

                    <Button 
                        className='mt-3 mb-3' 
                        onClick={ e => sendOTP(e)}> 
                        Request OTP 
                    </Button>
                    <br/>
                        { codeSent ? (<small > 
                            The OTP has been sent to your email. Please check your email (
                            <strong>including spam/junk</strong>).  If you have not received an email 
                            after a few minutes, please try again or contact us at 
                            <a href="mailto:csamwebteam@gmail.com"> csamwebteam@gmail.com</a>.
                        </small>) : (<></>) }

                    <div className= { showOtpInputField ? ("show"):("hide")}>
                        <Form.Group className="show mt-3">
                            <Form.Label style={{ fontWeight: "bold" }}> Enter OTP </Form.Label>
                            <Form.Control 
                            type="text"
                            value={userOTP}
                            onChange={e=>setUserOTP(e.target.value)}
                            placeholder=""/>
                            
                        </Form.Group>

                        <Button 
                            className='mt-2 verify-btn' 
                            style={{ float: "right", color: 'white'}} 
                            type="submit"
                            disabled={userOTP == ''}>
                            Verify OTP
                        </Button>
                    </div>



                    <small>
                        Don't have an account? <a href="/register"> Register </a>
                    </small>

                </Form>
            </Card.Body>
        </Card>
        )
    }

    const successVerifiedView = () => {
        return (
            <Card>
                <Card.Body>
                    Congratulations! 
                    Your account has been successfully verified, 
                    enhancing its security. 
                    Please <a href='' onClick={e=> {navigate('/login', {replace: true} )}}> log in </a>to access your account.
                </Card.Body>
            </Card>
        )
    }

    if (otpVerified) return (
        <Container className='mt-20vh'>
            <Row className='justify-content-center'>
                <Col className='mx-auto mw-500'>
                    <Card>
                        <Card.Body>
                            <h4 className='mb-3'> Thank you for verifying your account! </h4>
                            <p className='mb-3'>
                                Lastly, you must create a new password to access your account.
                            </p>
                            <p className='mb-3 text-center'>
                                <a href='/change-password' className='btn btn-primary ' onClick={ e=> {
                                    navigate('/change-password', {
                                        state: {
                                            email: email.toLowerCase(), 
                                            registrationType: registrationType == 'Password change'? ('Password change'):('newUser-verified')
                                        }, 
                                        replace: true
                                    })}}> Reset Password </a> 
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )

    if (!loadingOtpVerification && !otpVerified) return (
        (<Container>
            <Row className='mt-100 mb-100' style={{}}>
                <Col className='mx-auto mw-500'>
                    <Alert variant='danger' className={ errMsg == ''? ("hide"):("show")} >
                        { errMsg }
                    </Alert>
                    { !otpVerified ? ( otpFormView() ):( successVerifiedView()) }
                </Col>
            </Row>
        </Container>)
    )
}